import script from "./promotes-addon.vue?vue&type=script&lang=js"
export * from "./promotes-addon.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__